 'use strict';

import page from './page';
import util from './util';
import validator from './validator';
import menuCrosssell from './pages/menu-crosssell';

// method to execute page specific initialization
function initPageModule(pages) {
    // execute page specific initializations
    $.extend(page, window.pageContext);

    var ns = page.ns;

    if (ns && pages[ns] && pages[ns].init) {
        pages[ns].init();
    }
}

function resetFooterError() {
    $('.store-locator-form input[type="text"]').val('');

    if ($('.store-locator-form .field-button-container div').hasClass('error')) {
        $('.store-locator-form .field-button-container div').removeClass('error');
        $('.store-locator-form .field-button-container .error-message').remove();
    }
}

function playVideoHandler() {
    var MAIN_VIDEO_SELECTOR = '.main-video';
    var CAROUSEL_VIDEO_SELECTOR = '.modal-video';

    $(document)
        // main video (inline)
        .on('click', MAIN_VIDEO_SELECTOR, function () {
            var $this = $(this);

            var $inlineEle = $this.parent('div'),
                videoId = $this.data('video-id');

            video.playInline($inlineEle, videoId);
        })

        // carousel videos (launched in modal)
        .on('click', CAROUSEL_VIDEO_SELECTOR, function (e) {
            e.preventDefault();
            var videoId = $(this).data('video-id');

            video.playInModal(videoId);
        })

        .on('click', '.video-inline-container a[data-video-id]', function (e) {
            e.preventDefault();
            var $this = $(this);
            video.playInline(
                $this.closest('.video-inline-container'),
                $this.attr('data-video-id')
            );
        });

    // background videos auto play
    $(window).on('load', function () {
        var videoPlayer = $('.background-youtube-player');

        if (videoPlayer && videoPlayer.length > 0) {
            var videoId = videoPlayer.data('video-id');
            video.playInBackground(
                $('.image-video-wrap'),
                videoPlayer,
                videoId
            );
        }

        // inline nars-pro videos auto play
        var inlineVideoPlayer = $('.inlinenarpro-youtube-video-container');

        if (inlineVideoPlayer && inlineVideoPlayer.length > 0) {
            var inlineVideoId = inlineVideoPlayer.data('video-id');

            video.playInlineWOControls(
                $('.narspro-inner-content'),
                $('.inlinenarpro-youtube-wrapper'),
                inlineVideoId
            );
        }
    });
}

function responsiveMegaMenu() {
    var $dropdowns = $('.level-1 li.has-sub-menu');

    $dropdowns.on('keydown', function(e) {
        var $this = $(this);
        
        if (e.keyCode === 13) {
                
            if (!$this.hasClass('hover')) {
                e.preventDefault();

                $dropdowns.removeClass('hover');
                $this.addClass('hover');

            } 
        }

        if (e.keyCode === 32) {
            e.preventDefault();
            $dropdowns.removeClass('hover');
        }
    });
    

    $dropdowns.hover(function() {
        var $this = $(this);
        if ($this.prop('hoverTimeout')) {
            $this.prop('hoverTimeout', clearTimeout($this.prop('hoverTimeout')));
        }
        $this.prop('hoverIntent', setTimeout(function () {
            $this.addClass('hover');
        }, 200));
    }, function() {
        var $this = $(this);
        if ($this.prop('hoverIntent')) {
            $this.prop('hoverIntent', clearTimeout($this.prop('hoverIntent')));
        }
        $this.prop('hoverTimeout', setTimeout(function () {
            $this.removeClass('hover');
        }, 200));
    });

    if ('ontouchstart' in document.documentElement && window.innerWidth >= 640) {
    
        $dropdowns.each(function () {
            var $this = $(this);

            this.addEventListener('touchstart', function (e) {
                if (e.touches.length === 1) {
                    e.stopPropagation();

                    if (!$this.hasClass('hover')) {
                        if (e.target === this || e.target.parentNode === this) {
                            e.preventDefault();
                        }

                        $dropdowns.removeClass('hover');
                        $this.addClass('hover');

                        document.addEventListener('touchstart', function closeDropdown(e) {
                            e.stopPropagation();

                            $this.removeClass('hover');
                            document.removeEventListener('touchstart', closeDropdown);
                        });
                    }
                }
            }, false);
        });
    }
 
    $('a.no-link').on('click', function(e){
        if (window.innerWidth >= 768) {
            e.preventDefault();
        }
    });

    var ogMenuHeight = $('ul.level-1').height();
    // main menu toggle
    $(window).on('orientationchange', function () {
        $('body, #wrapper, #minimized-header-container').removeClass('menu-active');
    });
    $('.menu-toggle, .close-menu-overlay').on('click', function() {
        $('body, #wrapper, #minimized-header-container').toggleClass('menu-active');
        ogMenuHeight = $('ul.level-1').height();
    });
    
    $('body').click(function(evt){
        var $target = $(evt.target);
    	if($target.closest('#minimized-header-container').length == 0) {
    		$('body, #wrapper, #minimized-header-container').removeClass('menu-active');
            $('#minimized-header-container').find('.level-1 li').removeClass('active');
            
            var $container = $('#minimized-header-container').find('.main-nav');
            updateMenuState($container, 1);
    	 }
    });
   

    $('.main-nav li .menu-item-toggle').parent().children('a,span').on('click', function(e) {
        if (util.isMobile()) {
            e.preventDefault();
        }

        var $parentLi = $(e.target).closest('li');
        $parentLi.siblings('li').removeClass('active').find('.menu-item-toggle'); 
        $parentLi.toggleClass('active');

        var $container = $parentLi.closest('.main-nav');
        var stage = $container.attr('data-stage');
        if(stage && !isNaN(stage)) {stage = Number(stage);} else {stage=1;}
        stage++;
        updateMenuState($container, stage);
        
        $(e.target).toggleClass('active');
        menuCrosssell.init();
    });

    $('.mobile-menu-back').on('click', function() {
        var $closestActiveMenu =  $(this).closest('.active')
        var prevMenuHeight = $closestActiveMenu.parent().parent().height();

        $closestActiveMenu.removeClass('active');

        var $container = $closestActiveMenu.closest('.main-nav');
        var stage = $container.attr('data-stage');
        if(stage && !isNaN(stage)) {stage = Number(stage);} else {stage=2;}
        stage--;
        updateMenuState($container, stage);

        if (ogMenuHeight <= prevMenuHeight) {
            //$('ul.level-1').css('height', prevMenuHeight);
        }
    });

    $('.user-account').on('click', function(e) {
        e.preventDefault();

        $(this).parent('.user-info').toggleClass('active');
    });
}
function updateMenuState($container, stage) {
    $container.removeClass('menu-level-1 menu-level-2 menu-level-3 menu-level-4').attr('data-stage', stage).addClass('menu-level-'+stage);
}

//add class for scrollbar on miniline summary
function addSummaryScrollbar() {
    var itemCount = $('.pt_checkout .checkout-mini-cart .accordion-content .mini-cart-product').length;

    if (itemCount > 4) {
        $('.checkout-mini-cart .accordion-content').addClass('scroll-items');
    }
}

function backToTopHandler() {
    $(document).on('scroll', function() {
        if ($(window).scrollTop() > 100) {
            $('.scroll-top-wrapper').addClass('show');
        } else {
            $('.scroll-top-wrapper').removeClass('show');
        }
    });

    $(document).on('click', '.scroll-top-wrapper', util.scrollToTop);
}
function backToTopPLP() {
    $(document).on('click', '.btn-flat-black.back-to-top', util.scrollToTop);
}

// Minimize header and make it stick to the top
function minimizedHeaderHandler() {
    checkScrolledDown();

    $(window).on('scroll', function() {
    	checkScrolledDown();
    });
}

function checkScrolledDown(){

    var $stickyHeader = $('#minimized-header-container');
    var $headerScrollOffset = $('.cookies-slot').outerHeight();
    var $wrapper = $('#wrapper');

    if ($('body').hasClass('is-reveal-open')) {
        return false;
    }
}

//Stick Cross Navigation Bar in mobile devices
function crossNavBarHandler() {
    const $win    = $(window);
    const $cross  = $('#cross-cat-nav');
    const $mobile = $('.search-result-options-mobile');
    const $hdr    = $('#minimized-header-container');
    const $btnTop = $('.back-to-top');

    // nothing to do if neither exists
    if (!$cross.length && !$mobile.length) return;

    // 1) record original positions
    const origCrossTop  = $cross.length  ? $cross.offset().top  : null;
    const origMobileTop = $mobile.length ? $mobile.offset().top : null;

    // 2) scroll handler
    function onScroll() {
        const st       = $win.scrollTop();
        const hdrH     = $hdr.outerHeight(true);
        const hasCross = $cross.length > 0;

      // threshold = original top BEFORE sticking, minus header height
        const threshold = hasCross
        ? origCrossTop - hdrH
        : origMobileTop - hdrH;

        if (st >= threshold) {
            // — stick cross-nav if present
            if (hasCross) {
            $cross
                .addClass('sticky-cross-nav')
                .css('top', hdrH);
            }

            // — stick mobile bar beneath it (or as primary if no cross-nav)
            if ($mobile.length) {
                if (hasCross) {
                const crossH = $cross.outerHeight(true);
                $mobile
                .addClass('sticky-search-options')
                .css('top', hdrH + crossH);
            } else {
                $mobile
                .addClass('sticky-cross-nav')
                .css('top', hdrH);
            }
        }
        } else {
            // — unstick both
            $cross
            .removeClass('sticky-cross-nav')
            .css('top', '');

            $mobile
            .removeClass('sticky-cross-nav sticky-search-options')
            .css('top', '');
        }

        // back-to-top toggle
        if ($hdr.hasClass('sticky-header')) {
            $btnTop.addClass('visible');
        } else {
            $btnTop.removeClass('visible');
        }
    }

    // bind and invoke once
    $win.on('scroll resize', onScroll);
    onScroll();
}

function tutorialSliderInit(){
    $('.howto-slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.howto-slider-nav'
    });
    $('.howto-slider-nav').slick({
        slidesToShow: 7,
        slidesToScroll: 1,
        asNavFor: '.howto-slider-for',
        dots: false,
        arrows: true,
        centerMode: true,
        focusOnSelect: true,    
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
        ]    
    });
      
    $('#artistsVideos ul .artistsVideos-list').slick();
}

// Validation check for guest user login
function validateGuestUserLogin(){
    $('.checkoutlogin #guestcheckout').on('click',function(){
        var $checkoutForm = $('.login-box').find('form[id="dwfrm_login"]');
        $checkoutForm.removeClass('returningusercheckout').addClass('guestcheckout');
        validator.initForm($checkoutForm);
    });

    $('.checkoutlogin #login').on('click',function(){
        var $checkoutForm = $('.login-box').find('form[id="dwfrm_login"]');
        $checkoutForm.removeClass('guestcheckout').addClass('returningusercheckout');
        validator.initForm($checkoutForm);
    });
}

function searchMenuEvent(){
    // Search for mobile view
    $('.quick-access-menu [title="Search"]').on('click', function(e) {
        e.preventDefault();

        //$('.header-search-container').slideToggle(200);
    });

    // show the search button when the user switches to desktop view
    $(window).on('resize', function(e){
        if(window.innerWidth > 639){
            //$('.header-search-container').show();
        } 
    });
}

export default {
    initPageModule: initPageModule,
    resetFooterError: resetFooterError,
    playVideoHandler: playVideoHandler,
    responsiveMegaMenu: responsiveMegaMenu,
    addSummaryScrollbar: addSummaryScrollbar,
    backToTopHandler: backToTopHandler,
    backToTopPLP: backToTopPLP,
    minimizedHeaderHandler: minimizedHeaderHandler,
    crossNavBarHandler: crossNavBarHandler,
    tutorialSliderInit: tutorialSliderInit,
    validateGuestUserLogin: validateGuestUserLogin,
    searchMenuEvent: searchMenuEvent
}
